<template>
  <div class="xin">
    <div class="switch">
      <el-tabs v-loading="loading">
        <!-- regex -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.create_user1") }}</span>
          <div class="main">
            <!-- <el-button @click="save_rule_hide()">{{
              $t("logs.Policy_back")
            }}</el-button> -->

            <el-alert
              :title="this.SHOW_RELATION1"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>

          <div class="table ruel_find">
            <div class="find">
              <!--邮件账号-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.autu5_a2") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_username"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--昵称-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.depart8") }}: </span>
                  <el-input
                    type="text"
                    v-model="create_name"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--密码-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.user_list6") }}:
                  </span>
                  <el-input
                    type="password"
                    v-model="create_passwd1"
                    style="width:50%;"
                    show-password
                  >
                  </el-input>
                </div>
                <!--确认密码-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.user_list7") }}:
                  </span>
                  <el-input
                    type="password"
                    v-model="create_passwd2"
                    style="width:50%;"
                    show-password
                  >
                  </el-input>
                </div>
              </div>
              <!--容量-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.depart9") }}: </span>
                  <el-input
                    type="text"
                    v-model="create_maxspaces"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
                <!--最大网络磁盘-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.user_list_manage7") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_maxnetdisk"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--企业部门-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.depart2") }}: </span>
                  <el-select v-model="create_depart_id" style="width:50%">
                    <el-option
                      v-for="item in create_depart_id_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!-- 性别，vip ,禁用规则-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user2") }}:
                  </span>
                  <el-select
                    v-model="create_gender"
                    style="width:50%"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in create_gender_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!--vip-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user3") }}:
                  </span>
                  <el-select
                    v-model="create_isvip"
                    style="width:50%"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in create_isvip_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!--禁用规则-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user4") }}:
                  </span>
                  <el-select
                    v-model="create_secure_sw"
                    style="width:50%"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in create_secure_sw_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!--查询密码问题-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user7") }}:
                  </span>
                  <el-select
                    v-model="create_pwd_hint_question"
                    style="width:50%"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in create_spwd_hint_question_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!--查询密码答案-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user8") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_pwd_hint_answer"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--职务-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user5") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_duty"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
                <!--工号-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user6") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_jobnumber"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--最近登陆时间-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user9") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_time"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
                <!--最近登录ip -->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user10") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_ip"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--是否激活-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.depart18") }}:
                  </span>
                  <el-select
                    v-model="create_active"
                    style="width:50%"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in create_active_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text" style="visibility: hidden;"
                    >{{ $t("logs.depart18") }}:
                  </span>
                </div>
              </div>
            </div>

            <p class="create_information">{{ $t("logs.create_user11") }}</p>
            <!-- 基本信息 -->
            <div class="find" style="margin-top:0px">
              <!--公司-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user12") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_company"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--id-->
                <div class="block block1">
                  <span class="ruel_find_text">ID: </span>
                  <el-input
                    type="text"
                    v-model="create_id"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--QQ-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">QQ: </span>
                  <el-input
                    type="text"
                    v-model="create_qq"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--MSN-->
                <div class="block block1">
                  <span class="ruel_find_text">MSN: </span>
                  <el-input
                    type="text"
                    v-model="create_msn"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--座机-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user13") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_tele_number"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--Email-->
                <div class="block block1">
                  <span class="ruel_find_text">Email: </span>
                  <el-input
                    type="text"
                    v-model="create_email"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--省份-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user14") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_province"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--城市-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user15") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_city"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--手机-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user16") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_mobile_number"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--传真-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user17") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_fax_number"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--邮编-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user18") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_zipcode"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--联系地址-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user19") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_address"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
            </div>
            <el-row>
              <!-- 保存 -->

              <el-button type="primary" @click="save_create_user">{{
                $t("tab.save")
              }}</el-button>
              <!-- 取消 -->

              <!-- <el-button type="danger" @click="save11">{{ $t("tab.cancel") }}</el-button>-->
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label=""> </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        loading:false,
      SHOW_RELATION1: "",
      create_username:'',
      create_name:'',
      create_passwd1:"",
      create_passwd2:'',
    create_maxspaces:'',
    create_maxnetdisk:'',
    create_depart_id:'',
    create_depart_id_arr:[],
    create_gender:'',
    create_gender_arr:[],
     create_isvip:'',
    create_isvip_arr:[],
     create_secure_sw:'',
    create_secure_sw_arr:[],
    create_spwd_hint_question:'',
    create_spwd_hint_question_arr:[],
        create_pwd_hint_question:'',
    create_pwd_hint_question_arr:[],
        create_pwd_hint_answer:'',
        create_duty:'',
        create_jobnumber:'',
        create_time:'',
        create_ip:'',
create_active:'',
    create_active_arr:[],
create_company:'',
create_id:'',
create_qq:'',
create_msn:'',
create_tele_number:'',
create_email:'',
create_province:'',
create_city:'',
create_mobile_number:'',
create_fax_number:'',
create_zipcode:'',
create_address:'',


    }
  },
  mounted() {},
  methods: {
          save_create_user() {
      // this.user_list = false
      // this.edit_user = true
      // this.loading = true;
      // this.tanchu = false
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_admin",
        sid: sid,

        allow_ip: this.allow_ip,
        passwd2: this.passwd2,
        passwd1: this.passwd1,
        relation_email: this.relation_email,
        newadd: 1,
        admin: this.admin,
      });
      this.$axios
        .post(
          "/api/adm/cgi/admin.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList1();
            this.passwd2 = "";
            this.passwd1 = "";
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
  },

};
</script>
<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

.ruel_find .find {
  width: 100%;
}

.ruel_find .block {
  display: flex;
  align-items: center;
  // justify-content: center;
}

.ruel_find_text {
  margin-right: 8px;
  color: #0e2c5e;
  width: 150px;
  text-align: right;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
}

.ruel_find {
  /deep/ .el-button {
    padding: 8px 16px;
    // margin-left: 10px;
    font-size: 12px;
    // background: #eceff4;
    margin-top: 14px;
    margin-right: 10px;
  }

  .el-button--primary {
    background: #006be7;
  }

  .el-button--danger {
    background: #f05f5f;
  }
}
.create_information {
  // margin: 0 14px;
  text-align: left;
  // padding-left: 14px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #0e2c5e;
  // background: #ffffff;
  // border: 2px solid #d2d7e6;
  border-bottom: 0;
  line-height: 40px;
}
</style>
